import noop from '@hc-frontend/shared-assets/src/js/utils/fp/noop'
import getLocationByZip from 'core/services/getLocationByZip'
import getValueSelected from 'utils/DOM/getValueSelected'
import buildControllerZip from './buildControllerZip'
import toggleClass from 'utils/DOM/toggleClass'
import setOptions from 'utils/DOM/setOptions'
import getById from 'utils/DOM/getById'

let updateLocationCallback = noop

function loadOptions(zipCode, appState, county = '') {
  if (zipCode) {
    getLocationByZip(zipCode).then(response => {
      appState.lastLocations = response
      const counties = {}

      response.forEach(location => {
        counties[location.countyId] = location.countyName
      })

      setOptions(counties, appState.county, 'countyId-', county)

      toggleClass('#wrap-county', 'd-none', Object.keys(counties).length <= 1)

      const location =
        appState.lastLocations.find(loc => loc.countyName === county) || response[0]

      updateLocationCallback({
        appState,
        city: location.city,
        state: location.stateAcronym,
        stateName: location.stateName,
        zip: zipCode,
        county: location.countyName
      })
    })
  }
}

function disabledInputs(appState) {
  appState.county.disabled = true
}

function buildControllerZipCounty({
  form,
  handleUpdateLocation,
  prefix = '',
  county = ''
}) {
  updateLocationCallback = handleUpdateLocation
  const zipInput = form.zip
  const appState = {
    lastLocations: [],
    county: getById(`${prefix}county`),
    zip: buildControllerZip({
      input: zipInput,
      callStartLoading: () => {
        form.submit.disabled = true
        disabledInputs(appState)
      },
      callEndLoading: status => {
        if (status.valid) {
          loadOptions(status.value, appState, county)
        }

        form.submit.disabled = false
      }
    })
  }

  appState.zip.enableOnBlur()
  disabledInputs(appState)

  $(`#${prefix}county`).on('change', e => {
    const [key, value] = getValueSelected(e.target).split('-')
    const location = appState.lastLocations.find(loc => loc[key] === +value)

    updateLocationCallback({
      appState,
      city: location.city,
      state: location.stateAcronym,
      stateName: location.stateName,
      zip: location.zipCode,
      county: location.countyName
    })
  })

  return {
    setValue: ({ location }) => {
      // normalize values
      const zip = location.zip_code || location.zipCode
      const state = location.state_acronym || location.stateAcronym || ''
      const stateName = location.state || location.stateName || ''
      const county = location.countyName || location.county || ''

      updateLocationCallback({
        appState,
        city: location.city,
        state,
        stateName,
        zip,
        county
      })
      appState.zip.setValue(zip)
      loadOptions(zip, appState, county)
    },
    getStatus: () => {
      const zipStatus = appState.zip.getStatus()
      const countyId = +getValueSelected(appState.county).split('-')[1]
      const location = appState.lastLocations.find(loc => loc.countyId === countyId)

      const result = {
        valid: zipStatus.valid,
        value: {
          location
        }
      }

      return result
    },
    validate: () => {
      appState.zip.validate()
    },
    destroy: () => {
      appState.zip.destroy()
    }
  }
}

export default buildControllerZipCounty
